import { getFormValues } from "redux-form";
import { trimString } from "@utils";

export const getMainCheckoutAddress = type => async (dispatch, getState) => {
  const address = getFormValues("mainCheckoutBuy")(getState())[type];
  return {
    firstname: trimString(address.firstname),
    lastname: trimString(address.lastname),
    street: trimString(address.street),
    street2: trimString(address.street2),
    city: trimString(address.city),
    state: trimString(address.state),
    postcode: trimString(address.zip)
  };
};

export const getCustomerAddress = () => async (dispatch, getState) => {
  const customerInfo = getState().customerInfo;
  return {
    firstname: trimString(customerInfo.firstname),
    lastname: trimString(customerInfo.lastname),
    street: trimString(customerInfo.street),
    street2: trimString(customerInfo.street2),
    city: trimString(customerInfo.city),
    state: trimString(customerInfo.state),
    postcode: trimString(customerInfo.zip)
  };
};
